export var PhoneNumberRegexString = "^(([+0]{1}[0-9]{7,15})|([0-9]{8,16}))$";
export var PostalcodeRegexString = "^(([1-9])(\\d{3}))$";
export var HouseNumberRegexString = "^\\d{1,4}$";
export var EmailRegexString =
  '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
export var CoordinatesRegexString = "^[0-9]{1,16}(\\.[0-9]{0,9})?$";
